const restaurant = {
  restaurant: "Restaurante", // translated
  restaurants: "Restaurantes", // translated
  category: "Categoría", // translated
  score: "Puntaje", // translated
  priceQuartile: "Cuartil de precios", // translated
  scoreLowestFirst: "Puntuación (la más baja primero)", // translated
  scoreHighestFirst: "Puntuación (la más alta primero)", // translated
  priceLowestFirst: "Precio: el más bajo primero)", // translated
  priceHighestFirst: "Precio: más caros primero)", // translated
  allPrices: "Todos los precios", // translated
  reserve: "Reservar", // translated
  dining: "Comida", // translated
};


export default restaurant;
